import EventEmitter from 'eventemitter3';

class SheetEvents extends EventEmitter {}

export default SheetEvents;
